import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Tooltip } from '../Tooltip';
import { LabelWithHint } from './LabelWithHint';
import { BaseDisplay } from './styled';
export const Display = /*#__PURE__*/ forwardRef(({ level, hint, tooltip, tone, weight, elementType, children, ...rest }, ref)=>{
    let childrenUI = children;
    if (tooltip) {
        const tooltipProps = typeof tooltip === 'string' ? {
            title: tooltip,
            placement: 'top'
        } : tooltip;
        childrenUI = /*#__PURE__*/ _jsx(Tooltip, {
            ...tooltipProps,
            children: /*#__PURE__*/ _jsx("span", {
                children: childrenUI
            })
        });
    } else if (hint) {
        childrenUI = /*#__PURE__*/ _jsx(LabelWithHint, {
            hint: hint,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(BaseDisplay, {
        ...rest,
        tone: tone,
        weight: weight,
        as: elementType,
        level: level,
        ref: ref,
        children: childrenUI
    });
});
